import { Component } from '@angular/core';
/**
 * PrintViewComponent
 * This component is used to render the content that will be printed or displayed in a print view.
 */
@Component({
  selector: 'app-print-view',
  templateUrl: './print-view.component.html',
  styleUrl: './print-view.component.scss'
})
export class PrintViewComponent {

}
